'use client';
import React, { useState } from 'react';
import { Container } from '@/components/client/Container/Container';
import { Section } from '@/components/client/Section/Section';
import style from './Header.module.scss';
import logo from '@/public/icons/main_logo.webp';
import Image from 'next/image';
import { Nav } from './components/Nav/Nav';
import { cn } from '@/lib/utils';
import Link from 'next/link';
import { SideMenu } from './components/SideMenu/SideMenu';

import Button from '@/components/ui/Button/Button';
import { Icons } from '@/components/icons';
import { useModalContext } from '@/context/ModalsContext';
import { usePathname } from 'next/navigation';

export const Header = () => {
  const pathname = usePathname();
  const isAdminPath = pathname.includes('/admin');
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { setIsModalOpened } = useModalContext();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // console.log(isAdminPath, 'isAdminPath');

  return !isAdminPath ? (
    <Section
      styles={{
        position: 'sticky',
        top: '0',
        zIndex: '50',
        background: 'transparent',
        padding: '8px 0',
      }}
      variant="primary"
    >
      <Container>
        <header className={cn(style.header, 'w-full')}>
          <div className={style.headerContainer}>
            <div className="xl-custom:gap-6 container mx-auto flex min-w-0 items-center justify-between gap-3 px-0 sm:gap-4">
              <div className="flex shrink-0 items-center">
                <Link href={'/'} className="block">
                  <Image
                    src={logo}
                    alt="Tytum Logo"
                    className="h-auto w-[88px] sm:w-[100px]"
                    width={100}
                    height={40}
                  />
                </Link>
              </div>

              <div className="xl-custom:flex hidden min-w-0 flex-1 items-center justify-center">
                <Nav />
              </div>

              <div className="xl-custom:gap-5 flex shrink-0 items-center gap-2 sm:gap-3">
                <a
                  href="tel:+16193494397"
                  aria-label="Call (619) 349-4397"
                  className="xl-custom:justify-start flex min-h-11 min-w-11 touch-manipulation items-center justify-center gap-2 rounded-lg font-medium text-[#333333] hover:opacity-80 sm:min-h-0 sm:min-w-0"
                >
                  <Icons.headerPhone
                    className="xl-custom:size-[18px] size-[18px] shrink-0 sm:size-5"
                    strokeWidth={2}
                    aria-hidden
                  />
                  <span className="xl-custom:text-base whitespace-nowrap text-xs sm:text-sm">
                    (619) 349-4397
                  </span>
                </a>
                <div
                  onClick={() => setIsModalOpened(true)}
                  className="xl-custom:block hidden"
                >
                  <Button variant={'main'}>Contact Us</Button>
                </div>
                <div className="xl-custom:hidden">
                  <button
                    type="button"
                    onClick={toggleMenu}
                    className="flex min-h-11 min-w-11 touch-manipulation items-center justify-center rounded-lg"
                    aria-label="Toggle Menu"
                  >
                    <Icons.burgerIcon />
                  </button>
                </div>
              </div>
              {/*  <div className="ml-4 cursor-pointer">
                <Link href={'/admin/login'}>
                  <Icons.login />
                </Link>
              </div> */}
            </div>

            <SideMenu isOpen={isMenuOpen} onClose={toggleMenu} />
          </div>
        </header>
      </Container>
    </Section>
  ) : null;
};
